export var isRetina = function () { return window.devicePixelRatio >= 2; };
